import airbridge from 'airbridge-web-sdk-loader';
import { sentry } from '@myrealtrip/logger';

type AirbridgeEventOption = Parameters<typeof airbridge.events.send>[1];

/**
 * Airbridge Web SDK로 이벤트를 전송한다.
 *
 * `airbridge.events.send`를 래핑하여 try/catch 및 에러 로깅을 일원화한다.
 * 각 앱에서 `airbridge-web-sdk-loader`를 직접 import하지 않고 이 함수를 통해 사용한다.
 *
 * 전송 실패 시 console.error + sentry.capture로 기록하여 프로덕션 모니터링 누락을 방지한다.
 *
 * @example
 * logAirbridgeEvent('airbridge.ecommerce.product.viewed', {
 *   action: 'TICKET',
 *   semanticAttributes: { products: [{ productID: '123', price: 10000, currency: 'KRW' }] },
 * });
 */
export default function logAirbridgeEvent(category: string, option?: AirbridgeEventOption): void {
  try {
    airbridge.events.send(category, option);
  } catch (error) {
    console.error(`[airbridge] ${category} 이벤트 전송 실패:`, error);
    sentry.capture({
      error: error instanceof Error ? error : new Error(JSON.stringify({ error })),
      level: 'error',
      tags: {
        airbridgeCategory: category,
      },
    });
  }
}
